import type { PlainMessage } from '@bufbuild/protobuf';

import type {
  NoteTeethBlock,
  NoteTeethGroup,
} from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

import { NOTE_TEETH_GROUPS } from '../config';

// Scribe's `NoteTeethOfferedGroups`, which owns the rule: the groups a teeth
// field lists, in the protocol's order, or every group on a field that lists
// none, whether it takes one tooth or several.
export const noteTeethOfferedGroups = ({
  Groups,
}: Pick<PlainMessage<NoteTeethBlock>, 'Groups'>): NoteTeethGroup[] =>
  Groups.length
    ? NOTE_TEETH_GROUPS.filter((group) => Groups.includes(group))
    : NOTE_TEETH_GROUPS;
